import RelationshipMetadata from "../../RelationshipMetadata";

class AdminUserGroupAdminUserGroupEmployeeRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminUserGroupAdminUserGroupEmployeeRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminUserGroup";
        this.childEnterpriseComponent = "AdminUserGroupEmployee";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "UserGroupUSID";
    }
}

export default AdminUserGroupAdminUserGroupEmployeeRelationshipMetadata;